import { Trans } from '@lingui/react'
import { useState, type VFC } from 'react'

import IconTick from 'views/components/atoms/Icon/IconTick'
import Modal from 'views/components/molecules/Modal'
import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import Collapsible from 'views/components/organisms/Collapsible'

import { RX_BONUS_MODAL } from './const'

interface RxBonusModalProps {
  open?: boolean
  id?: string
}

const RxBonusModal: VFC<RxBonusModalProps> = ({ open = true, id }) => {
  const [collapsedState, setCollapsedState] = useState(false)

  return (
    <Modal
      id={id ?? RX_BONUS_MODAL}
      title={
        <Trans
          id="prescriptionBonus.modal.title.new"
          components={{ sup: <sup /> }}
        />
      }
      size="medium"
      isClientSideControlled={id ? false : true}
      open={open}
    >
      <div className="u-margin--bottom">
        <Trans id="prescriptionBonus.modal.intro" />
      </div>
      <ul className="a-list-reset u-font-weight--semi-bold">
        <div className="u-margin--bottom">
          <IconTick />
          <Trans id="prescriptionBonus.modal.check.publicPrescription" />
        </div>
        <div className="u-margin--bottom">
          <IconTick />
          <Trans id="prescriptionBonus.modal.check.minimalBonus" />
        </div>
        <div className="u-margin--bottom">
          <IconTick />
          <Trans
            id="prescriptionBonus.modal.check.freeDelivery"
            components={{ sup: <sup /> }}
          />
        </div>
      </ul>
      <div className="u-margin--bottom">
        <Trans id="prescriptionBonus.modal.outro" />
      </div>
      <Notification
        type={NOTIFICATION_TYPES.WARNING}
        label={
          <Trans
            id="prescriptionBonus.modal.warningNotification"
            components={{ sup: <sup /> }}
          />
        }
      />
      <div className="u-margin-large--top">
        <Collapsible
          label={<Trans id="prescriptionModal.faq.headline" />}
          id="prescription.bonus"
          allScreensizes
          headerColor="gray-150"
          expanded={collapsedState}
          handleClick={() => {
            setCollapsedState(!collapsedState)
          }}
        >
          <div className="u-margin--top u-margin--bottom u-margin-rebranding--none">
            <Trans id="prescriptionModal.faq.message" />
          </div>
        </Collapsible>
      </div>
    </Modal>
  )
}

export default RxBonusModal
